<template lang="pug" src="./brand-editor.pug"></template>

<script>
import request from '@/utils/request';

import validate from '@/mixins/validate';
import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';

import { mapState } from 'vuex';

export default {
    mixins: [validate, validationMixin],
    data: () => ({
        brand: {
            code: null,
            title: null,
            tax: null,
            phoneNumber: null,
            domain: null,
            defaultOptionId: null,
            fromCurbOptionId: null
        },
        loading: false,
        requestProcessing: false,
        canSaveBrand: false
    }),
    validations: {
        brand: {
            ...Object.assign({}, ...[
                'code', 'title', 'phoneNumber'
            ].map(param => ({
                [param]: {
                    required
                }
            }))),
            tax: { required, numeric }
        }
    },
    computed: {
        ...mapState({
            tariffs(state) {
                const brandOptions = state.data.brandOptions;
                const { id: brandId } = this.$route.params;

                if (!brandId) {
                    return [];
                }

                return brandOptions && brandOptions[brandId]
                    && brandOptions[brandId].tariffs || [];
            },
        }),
        isEdit() {
            return !!this.$route.params.id;
        }
    },
    watch: {
        brand: {
            handler() {
                this.canSaveBrand = true;
            },
            deep: true
        }
    },
    created() {
        if (this.isEdit) {
            this.loading = true;
            this.loadData();
        }
    },
    methods: {
        async loadData() {
            const { id } = this.$route.params;

            await request({ method: 'get', url: `/admin/brands/${id}` })
                .then(res => this.successLoad(res))
                .catch(error => this.errorHandler(error))
                .finally(() => this.loading = false);

            await this.$store.dispatch('data/getOptions');
        },

        async saveBrand() {
            if (this.$v.brand.$invalid) {
                this.$v.brand.$touch();
                this.$nextTick(() => this.focusFirstErrorInput());
                return;
            }

            if (this.requestProcessing) return;

            this.requestProcessing = true;

            const { id } = this.$route.params;
            const method = id ? 'put' : 'post';
            const url = id ? `/admin/brands/${id}` : '/admin/brands';

            await request({ method, url, data: this.brand})
                .then(res => {
                    this.successLoad(res);

                    this.$store.dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    });

                    if (this.brand.id && !id) {
                        this.$router.push(`/brands/editor/${res.data.id}`);
                    }

                    this.$v.brand.$reset();
                }).catch(error => {
                    this.errorHandler(error);
                }).finally(() => this.requestProcessing = false);
        },

        successLoad(res) {
            this.brand = Object.assign({}, this.form, res.data);

            this.$nextTick(() => {
                this.canSaveBrand = false;
                this.loading = false;
            });
        },

        errorHandler(error) {
            const message = error.response && error.response.data && error.response.data.error;

            if (message) {
                this.$store.dispatch('alert/addMessage', {
                    message: `brand.${message}`,
                    time: 2000
                });
            }

            if (error.response.status === 404) {
                this.$router.push('/resales/brands');
            }
        }
    }
};
</script>
